import { useQuery } from "@tanstack/react-query";
import Table from "../common/Table";
import Button from "../common/Button";
import { leadService } from "../../services/leads";
import { format } from "date-fns";
import { exportToCsv } from "../../utils/exportCsv";
import { Download } from "lucide-react";

const LeadTable = ({ filters, onEdit, onDelete }) => {
  const { data: leads, isLoading } = useQuery({
    queryKey: ["leads", filters],
    queryFn: () => leadService.getAll(filters),
  });

  const columns = [
    { header: "Name", accessor: "name" },
    { header: "Phone", accessor: "phone" },
    { header: "Email", accessor: "email" },
    { header: "Source", accessor: "source" },
    { header: "Status", accessor: "status" },
    {
      header: "Follow Up",
      accessor: (row) =>
        row.followUpDate ? format(new Date(row.followUpDate), "dd MMM") : "-",
    },
  ];

  const actions = (row) => (
    <>
      <Button
        variant="secondary"
        className="mr-2"
        onClick={() => onEdit(row)}
      >
        Edit
      </Button>
      <Button
        variant="danger"
        onClick={() => onDelete(row._id)}
      >
        Delete
      </Button>
    </>
  );

  if (isLoading) return <div>Loading...</div>;

  return (
    <div>
      <div className="flex justify-end mb-3">
        <button
          onClick={() => exportToCsv("leads", leads, columns)}
          className="flex items-center gap-1.5 px-3 py-1.5 text-sm text-gray-600 hover:text-gray-800 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
        >
          <Download className="w-4 h-4" />
          Export CSV
        </button>
      </div>
      <Table columns={columns} data={leads} actions={actions} />
    </div>
  );
};

export default LeadTable;
